import type { ValidationErrors } from '../../../../../utils/validation';
import { translateKey } from '../../../../../translate';
import { HeaderDivider, InputTextArea } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../../../../elements/forms/HorizontalFormGroup';
import { InputContainer } from '../../../../elements/forms/InputContainer';

interface IQuestionProps {
    automation?: string;
    errors: ValidationErrors;
    onChange: (value: string | null) => Promise<void>;
    onDoValidate: (isCustomControlData?: boolean) => Promise<void>;
    question: string | null;
}

export function Question(props: IQuestionProps) {
    return (
        <>
            <HeaderDivider text={translateKey('request.questionPlaceholder')} />
            <HorizontalFormGroup hasErrors={props.errors.has('question')}>
                <FormLabel isRequired>{translateKey('request.question')}</FormLabel>
                <InputContainer>
                    <InputTextArea
                        automation={props.automation}
                        error={props.errors.get('question')}
                        onChange={async (value) => await props.onChange(value)}
                        onDoValidate={async () => await props.onDoValidate()}
                        placeholder={translateKey('request.questionPlaceholder')}
                        value={props.question}
                    />
                </InputContainer>
            </HorizontalFormGroup>
        </>
    );
}
